<template>
  <button class="login">
    <span
      v-if="isLogged"
      @click="gotoProfile"
    >Mi perfil</span>

    <span
      v-else
      @click="doLogin"
    >Inicia sesión <i class="far fa-user-circle fa-lg"></i></span>
  </button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'edi-user-menu-mobile',
  props: {
    partnerUrl: String
  },
  computed: {
    ...mapGetters([
      'isLogged',
      'loginUrl',
      'redirectUrl',
      'profileUrl'
    ])
  },
  methods: {
    gotoProfile() {
      window.location.href = this.profileUrl;
    },
    doLogin() {
      window.dataLayer.push({
        event: 'click_login',
        eventData: {
          im_location: 'burger_menu_mobile'
        }
      });
      fetch(`${this.redirectUrl}?op=saveref`, {method: 'GET'})
        .then(() => {
          // aquí deberíamos comprobar si res.status !== 200 o !res.ok para
          // validar el estado de la respuesta, pero el servicio de api
          // de callback devuelve siempre 404, así que no comprobamos nada.
          window.location.href = this.loginUrl;
        })
        .catch(err => {
          // sólo si err.status === 50x
          console.error(err);
        });
    }
  }
}
</script>
